import React, {useEffect} from 'react';
import {Container,} from '@mui/material';
import {Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

const Big5Chart = ({ results }) => {

  useEffect(() => {
    results.forEach(result => {
      result.domain =
        result.domain[0] === "N" ? "Neuroticism"
        : result.domain[0] === "E" ? "Extraversion"
        // : result.domain[0] === "O" ? "Openness To Experience"
        : result.domain[0] === "O" ? "Openness"
        : result.domain[0] === "C" ? "Conscientiousness"
        : result.domain[0] === "A" ? "Agreeableness"
        : "Unknown"
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{display: "flex", justifyContent: "center"}}>
      <Container style={{padding: "0 3em 0 1.5em"}}>
        <ResponsiveContainer width="100%" height={(results.length * (18 + 2)) + 40}>
          <BarChart layout="vertical" data={results} barCategoryGap={1}>
            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis tick={{fontSize: "10px"}} hide={false} type="number" domain={[0, 120]}/>
            <YAxis hide={true} dataKey="domain" type="category"/>
            <Tooltip/>
            {/*<Legend />*/}
            <Bar dataKey="score" fill="#ef8354">
              <LabelList dataKey="domain" position="insideLeft" fill={"#fff"}
                         style={{fontSize: "0.85rem", fontWeight: 600, color: "#fff"}}/>
              <LabelList dataKey="score" position="right" style={{fontSize: "0.7225rem"}}/>
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Container>
    </div>
  )
}

export default Big5Chart